import * as z from 'zod';

export const urlSchemeNative = z.url();

export function urlSchema(optional = true) {
  return z.string().refine((v) => (optional && v?.trim() === '' ? true : urlSchemeNative.safeParse(v).success), {
    error: 'Invalid Url Address',
  });
}
